export default {
  placeholder: 'Search business...',
};
